module.exports = __webpack_public_path__ + "static/media/pic3.894bfe0a.jpg";